export interface CropResult {
  canvas: HTMLCanvasElement;
  blob: Blob;
  file: File;
  dataURL: string;
}

export const useImageCropper = () => {
  const isClient = process.client;

  const isImageFile = (file: File): boolean => {
    if (!file || !file.type) return false;
    return file.type.startsWith("image/");
  };

  const getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
    if (!isClient) {
      return Promise.reject(new Error("Image dimensions can only be calculated on client side"));
    }

    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Failed to load image for dimension calculation"));
      };

      img.src = url;
    });
  };

  return {
    isImageFile,
    getImageDimensions,
    isClient,
  };
};
